/* eslint-disable no-shadow */
import React from 'react';
import { injectIntl } from 'react-intl';
import { notification } from 'antd';
import { Panel } from 'components/ui/index';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import Enums from 'utils/EnumsManager';
import { getStore } from 'utils/localStorage';
import styles from './index.less';
import PanelAction from './panelAction';
import ReportList from './reportList';
import { tryFetchFieldsMetaDataIfNeeded } from 'store/metaData/fields/actions';
import {
  fetchDashboardReportData,
  refreshSlot,
  setActiveDashboard,
  refreshReport,
  fetchSlotData,
  reSetDashboard,
} from '../../flow/action';


const cx = classNames.bind(styles);

const { WEBSOCKET, LocalStorageKeys } = Enums;
const { EVENTS, TYPE } = WEBSOCKET;
const { User } = LocalStorageKeys;


const errorNotification = text =>
  notification.error({
    duration: 3,
    message: text,
  });

class RightSection extends React.Component {
  componentDidMount() {
    const {
      fetchDashboardReportData,
      activeDashboard,
      tryFetchFieldsMetaDataIfNeeded,
    } = this.props;
    fetchDashboardReportData(activeDashboard);
    tryFetchFieldsMetaDataIfNeeded();
    this.initSocketEvent();
  }

  componentWillReceiveProps(nextProps) {
    const { intl } = this.props;
    const { formatMessage } = intl;
    const { dashboard_slots } = nextProps.rightSideData;
    if (dashboard_slots && !_.isEmpty(dashboard_slots) && !_.isEmpty(_.differenceWith(dashboard_slots, this.props.rightSideData.dashboard_slots, _.isEqual))) {
      const dataHasErrors = dashboard_slots.some(slot =>
        slot &&
        slot.bind_data_source &&
        (_.has(slot.bind_data_source, 'errors') || slot.bind_data_source.last_refresh_refresh_result !== 'success'));
      if (dataHasErrors) {
        errorNotification(formatMessage({ id: 'page.dashboard.errors.fieldsError' }));
      }
    }
  }

  componentWillUnmount() {
    const { reSetDashboard } = this.props;
    reSetDashboard();
  }

  initSocketEvent = () => {
    const user = getStore(User);
    const parsedUser = JSON.parse(user);
    window.Echo.addPrivateChannel(
      parsedUser.id,
      EVENTS.DASHBOARD_REFRESH_FINISHED,
      data => {
        const {
          activeDashboard,
          fetchSlotData,
          fetchDashboardReportData,
          rightSideData
        } = this.props;
        const { refresh_result, refresh_object_type, refresh_object_id } = data;

        if (_.isEmpty(data) || _.isEmpty(refresh_object_type) || !rightSideData || !_.isArray(rightSideData.dashboard_slots) || window.location.pathname.indexOf('dashboard') < 0) return;
        if (refresh_object_type === TYPE.DASHBOARD && refresh_object_id === Number(activeDashboard)) {
          fetchDashboardReportData(activeDashboard);
        }
        if (refresh_object_type === TYPE.DASHBOARDSLOT) {
          rightSideData.dashboard_slots.forEach(slot => {
            if (slot.dashboard_id === Number(activeDashboard) && slot.id === Number(refresh_object_id)) {
              fetchSlotData(refresh_object_id);
            }
          });
        }
      }
    );
  };

  render() {
    const {
      rightSideData,
      reportOptions,
      refreshSlot,
      setActiveDashboard,
      activeDashboard,
      fetchDashboardReportData,
      refreshReport,
      fieldsInfo,
    } = this.props;
    return (
      <Panel
        panelClasses={`creamyWhite-header-panel ${cx('right-session-panel')}`}
        panelTitle={rightSideData.name}
        actionsRight={
          <PanelAction
            rightSideData={rightSideData}
            reportOptions={reportOptions}
            setActiveDashboard={setActiveDashboard}
            activeDashboard={activeDashboard}
            fetchDashboardReportData={fetchDashboardReportData}
            refreshReport={refreshReport}
          />
        }
      >
        {
          rightSideData &&
            <ReportList
              slotsData={_.isArray(rightSideData.dashboard_slots) ? rightSideData.dashboard_slots : []}
              refreshSlot={refreshSlot}
              fieldsInfo={fieldsInfo}
              activeDashboard={activeDashboard}
            />
        }
      </Panel>
    );
  }
}

const mapStateToProps = ({ global, dashboard, metaData }) => ({
  lang: global.language,
  rightSideData: dashboard.reportDashboard,
  reportOptions: dashboard.reportOptions,
  activeDashboard: dashboard.reportActiveDashboard,
  fieldsInfo: metaData.fields.data,
});
const mapDispatchToProps = {
  fetchDashboardReportData,
  refreshSlot,
  setActiveDashboard,
  refreshReport,
  fetchSlotData,
  tryFetchFieldsMetaDataIfNeeded,
  reSetDashboard,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(RightSection));



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/rightSection/index.jsx